export default function getAnswerTimeTableFields(ctx) {
	return [
		{
			field: "order_id",
			title: ctx.$t("orderId") + " №",
			align: "center"
		},
		{
			field: "chat_id",
			title: ctx.$t("chat"),
			align: "center"
		},
		{
			field: "manager",
			title: ctx.$t("manager"),
			align: "center"
		},
		{
			field: "website",
			title: ctx.$t("site"),
			align: "center"
		},
		{
			field: "date",
			title: ctx.$t("date"),
			align: "center"
		},
		{
			field: "reply_time",
			title: ctx.$t("answerTime"),
			align: "center"
		},
	];
}